import { EMAIL_MESSAGE_STATUSES, PaymentMethods } from '../../../../../../services/exports/Constants';
import TemplateNames from '../email-messages/TemplateNames';

export default {
  page_title: 'Følgere',
  fields: {
    name: 'Navn:',
    email: 'E-mail:',
    phone_number: 'Telefon:',
    subscribed: 'Tilmeldt:',
    birthday: 'Fødselsdag:',
    location: 'Sted:',
    followed: 'Fulgt:',
    lifetime_spent: 'Samlet forbrug:',
    total_orders: 'Ordrer i alt:',
    google_review: 'Google-anmeldelse:',
    loyalty_lifetime: 'Loyalitet i alt:',
    loyalty_points: 'Loyalitet i dag:',
  },
  labels: {
    yes: 'Ja',
    no: 'Nej',
    followed_since_date: 'Siden {{date}}',
  },
  buttons: {
    edit: 'Rediger',
    request_data_deletion: 'Anmod om sletning af data',
  },
  toasts: {
    failed_to_load_data: 'Kunne ikke indlæse data',
  },
  tabs: {
    recent_orders: {
      title: 'Seneste ordrer',
      columns: {
        order_id: 'Id',
        items: 'Varer',
        total: 'Samlet beløb',
        paid_on: 'Betalt den',
        payment_method: 'Betalingsmetode',
      },
      labels: {
        no_orders: 'Ingen ordrer endnu',
      },
      payment_methods: {
        [PaymentMethods.CARD]: 'Kort',
        [PaymentMethods.PAYPAL]: 'PayPal',
        [PaymentMethods.APPLE_PAY]: 'Apple Pay',
        [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
        [PaymentMethods.LINK]: 'Link',
        [PaymentMethods.SOFORT]: 'Sofort',
        [PaymentMethods.IDEAL]: 'iDEAL | Wero',
        [PaymentMethods.BANCONTACT]: 'Bancontact',
        [PaymentMethods.EPS]: 'EPS',
        [PaymentMethods.P24]: 'Przelewy24',
        [PaymentMethods.BLIK]: 'BLIK',
        [PaymentMethods.TWINT]: 'TWINT',
        [PaymentMethods.VENMO]: 'Venmo',
        [PaymentMethods.WERO]: 'Wero',
        [PaymentMethods.KLARNA]: 'Klarna',
        [PaymentMethods.TRUSTLY]: 'Trustly',
        [PaymentMethods.PIX]: 'Pix',
        [PaymentMethods.NUPAY]: 'NuPay',
        [PaymentMethods.GIROPAY]: 'Giropay',
        [PaymentMethods.SEPA_DEBIT]: 'Bankbetaling',
        [PaymentMethods.CASH]: 'Kontant',
        [PaymentMethods.BACS_DEBIT]: 'Bankbetaling',
      },
    },
    messages: {
      title: 'Beskeder',
      columns: {
        template: 'Skabelon',
        status: 'Status',
        opened: 'Åbnet',
        clicked: 'Klikket',
        spam_complaint: 'Spamklage',
        unsubscribed: 'Afmeldt',
        sent_at: 'Sendt',
      },
      labels: {
        yes: 'Ja',
        no: 'Nej',
        not_detected: 'Ikke registreret',
        opened_at: 'Åbnet {{date}}',
        clicked_at: 'Klikket {{date}}',
        complained_at: 'Klaget {{date}}',
        unsubscribed_at: 'Afmeldt {{date}}',
        no_messages: 'Ingen beskeder endnu',
      },
      message_statuses: {
        [EMAIL_MESSAGE_STATUSES.SENT]: 'Sendt',
        [EMAIL_MESSAGE_STATUSES.DELIVERED]: 'Leveret',
        [EMAIL_MESSAGE_STATUSES.FAILED]: 'Mislykkedes',
      },
      template_names: {
        ...TemplateNames,
      },
      toasts: {
        failed_to_load_data: 'Kunne ikke indlæse data',
      },
    },
    balance_history: {
      title: 'Saldohistorik',
      columns: {
        created_at: 'Dato',
        source: 'Kilde',
        value: 'Point',
        points_expire_at: 'Udløber',
      },
      labels: {
        source: {
          welcome_bonus: 'Velkomstbonus',
          google_review_reward: 'Belønning for Google-anmeldelse',
          reward_loyalty_program_conversion: 'Belønning for konvertering af loyalitetsprogram',
          cashback: 'Cashback',
          refund: 'Refusion',
          cashback_usage: 'Brug af cashback',
          cashback_usage_refund: 'Refusion af cashback-brug',
          expired_points_void: 'Annullering af udløbne point',
          mobile_app_signup_bonus: 'Tilmeldingsbonus til mobilapp',
        },
        no_operations: 'Ingen handlinger endnu',
      },
    },
  },
};
